import { type UseMutationOptions, useMutation } from "@tanstack/react-query"
import type { ParsedAddress, PostalCodeResponse } from "./models"

const POSTAL_CODE_API_BASE_URL = "https://jp-postal-code-api.ttskch.com/api/v1"

async function fetchAddressByPostalCode(postalCode: string): Promise<ParsedAddress | null> {
  const response = await fetch(`${POSTAL_CODE_API_BASE_URL}/${postalCode}.json`)

  if (!response.ok) {
    return null
  }

  const data: PostalCodeResponse = await response.json()
  const ja = data.addresses[0]?.ja
  const kana = data.addresses[0]?.kana

  if (!ja) {
    return null
  }

  return {
    prefecture: ja.prefecture ?? "",
    prefectureKana: kana?.prefecture ?? "",
    city: ja.address1 ?? "",
    cityKana: kana?.address1 ?? "",
    town: `${ja.address2 ?? ""}${ja.address3 ?? ""}`,
    townKana: `${kana?.address2 ?? ""}${kana?.address3 ?? ""}`,
    district: ja.address4 ?? "",
    districtKana: kana?.address4 ?? "",
    fullAddress: `${ja.prefecture ?? ""}${ja.address1 ?? ""}${ja.address2 ?? ""}${ja.address3 ?? ""}${ja.address4 ?? ""}`,
  }
}

/**
 * 郵便番号から住所を検索するカスタムフック
 * @param options
 * @returns
 */
export function useSearchAddressByPostalCode(
  options?: UseMutationOptions<ParsedAddress | null, Error, string>
) {
  return useMutation({
    mutationFn: fetchAddressByPostalCode,
    ...options,
  })
}
